import { render, staticRenderFns } from "./sfd.vue?vue&type=template&id=c3428828"
import script from "./sfd.vue?vue&type=script&lang=ts"
export * from "./sfd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports